import clc from "cli-color";

export default class Console{

    static log(message=""){
        console.log(message);
    }

    static success(message=""){
        console.log(clc.green(message));
    }

    static info(message=""){

        console.log(clc.blueBright(message));
    }

    static warn(message=""){
        console.log(clc.yellow(message));
    }

    static error(message=""){
        throw new Error(clc.red.bold(message))
    }

}